import { render } from "./SlotsView.vue?vue&type=template&id=5f12566c&scoped=true"
import script from "./SlotsView.vue?vue&type=script&lang=js"
export * from "./SlotsView.vue?vue&type=script&lang=js"

import "./SlotsView.vue?vue&type=style&index=0&id=5f12566c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f12566c"]])

export default __exports__